import BezierEazing from 'bezier-easing';
import YandexEcommerce from 'components/yandex/ecommerce';

/**
 * Вызов события по подписке
 */
export const triggerEvent = (event_name, ...data) => {
    window.triggerSubscribers = typeof window.triggerSubscribers === 'object' ? window.triggerSubscribers : [];

    // инициализируем
    window.triggerSubscribers[event_name] = window.triggerSubscribers[event_name] || {
        triggered: false,
        data: {},
        callbacks: []
    };

    // отмечаем вызов и сохраняем данные
    window.triggerSubscribers[event_name].triggered = true;
    window.triggerSubscribers[event_name].data = data;

    // вызываем всех
    let result;
    window.triggerSubscribers[event_name].callbacks.filter(callback => {
        return !callback.triggered;
    }).forEach(callback => {
        result = callback.callback.apply(null, data);

        // ставим true если нужно вызвать 1 раз
        callback.triggered = !callback.options.multiple;
    });

    return result;
}

/**
 * Форматирование даты
 * @param  {Date} date Дата
 * @return {String}    Дата в формате - 8 март, чт
 */
export const getDateTitleFormatted = function(date, format = '') {
    if (!date || !(date instanceof Date)) {
        return '';
    }

    let shortMonthNames = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];

    // данные
    // let month     = new Intl.DateTimeFormat('ru-RU', {month: 'short'}).format(date).replace('.', '');
    let month   = shortMonthNames[date.getMonth()]
    let weekday = new Intl.DateTimeFormat('ru-RU', {weekday: 'short'}).format(date);

    // перечисление форматов
    if (format === 'noWeekday') {
        return date.getDate() + ' ' + month;
    }

    if (format === 'withYear') {
        return date.getDate() + ' ' + month + ' ' + date.getFullYear() + ', <font color="#8C8C8C">' + weekday + '</font>';
    }

    return date.getDate() + ' ' + month + ', <font color="#8C8C8C">' + weekday + '</font>';
}

/**
 * Подписка на событие
 */
export const subscribeEvent = (event_name, callback, options = {}) => {
    if (typeof callback != 'function') {
        return false;
    }

    window.triggerSubscribers = typeof window.triggerSubscribers === 'object' ? window.triggerSubscribers : [];

    // инициализируем
    window.triggerSubscribers[event_name] = window.triggerSubscribers[event_name] || {
        triggered: false,
        data: {},
        callbacks: []
    };

    // добавляем в стек
    window.triggerSubscribers[event_name].callbacks.push({
        triggered: false,
        callback,
        options: {
            multiple: options.multiple || true,
        }
    });

    // если вызов уже был (поздно подписались, то вызываем)
    if (window.triggerSubscribers[event_name].triggered) {
        triggerEvent(event_name, window.triggerSubscribers[event_name].data)
    }
}

/**
 * Обновляем счетчик для сердечка избранного
 */
export const updateFavorites = (count) => {
    const $favoritesCount = document.querySelectorAll('.Favorites--count, .Header__favorite, .js-favoriteCounter');
    if ($favoritesCount && $favoritesCount.length) {
        $favoritesCount.forEach($counter => {
            if (count > 0) {
                $counter.setAttribute('data-after', count);
            } else {
                $counter.removeAttribute('data-after');
            }
        });
    }
}

/**
 * Форматирование строки денег
 */
export const formatMoney = (n, c = 2, d = '.', t = ' ') => {
        n = String(n).replace(/\s/, '');

        let s, i, j;
        c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        j = (j = i.length) > 3 ? j % 3 : 0;

    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t);
}

/**
 * Асинхронная загрузка скриптов
 */
export const loadScript = (url) => {
    if (Array.isArray(url)) {
        let self = this;
        let prom = [];
        url.forEach(function (item) {
            prom.push(self.script(item));
        });

        return Promise.all(prom);
    }

    return new Promise((resolve, reject) => {
        let r = false;
        let t = document.getElementsByTagName('script')[0];
        let s = document.createElement('script');

        s.type = 'text/javascript';
        s.src = url;
        s.async = true;
        s.onload = s.onreadystatechange = function () {
            if (!r && (!this.readyState || this.readyState === 'complete')) {
                r = true;
                resolve(this);
            }
        };
        s.onerror = s.onabort = reject;
        t.parentNode.insertBefore(s, t);
    });
}

/**
 * Глобальный обработчик ошибок
 */
export const error = (e) => {
    const data = {
        'error_message': e.message,
        'file': e.filename,
        'line_number': e.lineno,
        'column_number': e.colno,
        'location': window.location.href,
        'screen_height': window.visualViewport.height,
        'screen_width': window.visualViewport.width,
    };

    if (e.error && e.error.stack) {
        data['stack'] = e.error.stack;
    }

    if (data.error_message == 'ResizeObserver loop limit exceeded'
        || data.error_message == 'Uncaught EvalError: Possible side-effect in debug-evaluate') {
        return;
    }

    console.error(e);

    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
        formData.append(key, value);
    }

    delay(() => {
        fetch('/main/js_error_handler/', {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
        });
    }, 500);
}

export const jsDots = (filterCount = 0) => {
    // страницы с фильтрами
    if (filterCount > 0) return false;

    const $dots = document.querySelectorAll('.js-dots:not(.js-initializaded)');
    if ($dots.length > 0) {
        $dots.forEach(($item) => {
            const $tagList = $item.querySelectorAll('li');
            let classes = '';
            let sum = 0,
                dots = 28,
                padding = 23,
                width = $item.offsetWidth;

            // не удалось получить ширину
            if (width === 0 || $tagList.length === 0) {
                return true;
            }

            // считаем
            $tagList.forEach(($tag) => {
                const w = $tag.offsetWidth + padding;
                if (width - dots < sum + w) {
                    $tag.remove();
                } else {
                    sum += w;
                }

                classes = $tag.getAttribute('class');
            });

            $item.classList.add('js-initializaded');

            // добавляем точки
            const $div = document.createElement('div');
            $item.appendChild($div);
            $div.outerHTML = `<li class="${classes}">...</li>`;
        });
    }
}

/**
 * Стоит кука с debug
 */
export const hasDebug = () => {
    return document.cookie.indexOf('debug=1') !== -1;
}

/**
 * Отладочная информация
 */
export const log = (...args) => {
    if (document.cookie.indexOf('debug=1') !== -1) {
        console.log(...args);
    }
}

/**
 * Время генерации страницы
 */
export const pageGenerateTime = () => {
    if (document.cookie.indexOf('debug=1') !== -1) {
        const debug = {
            generateTime: document.body.dataset.generate_time || Date(),
            version: document.body.dataset.version || '',
            pageSubscribers: window.triggerSubscribers || {},
            pageTriggers: window.triggerList || {}
        };

        if(document.readyState !== 'loading') {
            console.log(debug);
        } else {
            window.addEventListener('DOMContentLoaded', () => console.log(debug));
        }
    }
}

/**
 * JS обработчик кликла по ссылки, замена <a>
 * window сделан чтобы работал вызов с html элементов
 */
export const jsLink = (url, target, elem, callback) => {
    if (!url) return false;

    let phone = /^tel:/
    let http = /^http/
    let social = /^(skype|viber|whatsapp)/
    let origin = window.location.origin;

    // если ссылка телефон
    if (phone.test(url)) {
        const classText = elem.classList.contains('Phone') ? 'class="Phone"' : '';

        let parent = elem.parentNode,
            tempDiv = document.createElement('div');
            tempDiv.innerHTML = `<a href="${url}" ${classText}>${elem.textContent}</a>`;

        var input = tempDiv.childNodes[0];

        parent.replaceChild(input, elem);

        return false;
    }

    // если ссылка social
    if (social.test(url) && elem) {
        window.location.href = decodeURI(url);
        return false;
    }

    // проверка на формат ссылки
    if (!http.test(url) && !social.test(url)) {
        url = origin + url;
    }

    // пытаемся отловить событие клика
    var e = window.event;
    var btnCode = -1;
    if ('object' === typeof e) {
        btnCode = e.button;
    }

    // не клик
    switch (btnCode) {
        case -1: // firefox
        case 0: // клик левой кнопкой
            if (typeof callback === 'function') {
                callback();
            }
            if (target === '_blank') {
                window.open(url, '_blank');
            } else {
                window.location.href = url;
            }
            break;
        case 1: // клик колесиком
            window.open(url, '_blank');
            break;
    }

    return false
}

// TODO перенести обработчик
// window.jsLink

/**
 * Верския сайта
 */
export const version = () => {
    return document.body.dataset.version || '';
}

/**
 * Кнопка наверх
 */
export const activateScrollUpButton = () => {
    return; // кнопка отключена 2024-12-04

    const backButton = document.querySelector('.js-button-back');
    if (backButton === null || ['YaBrowser', 'Mobile'].every(word => navigator.userAgent.includes(word))) {
        return;
    }

    function activeButtonBack() {
        const scrollHeight = window.pageYOffset;

        if (scrollHeight > 500) {
            backButton.classList.add('is-active');
        } else {
            backButton.classList.remove('is-active');
        }
    }

    backButton.addEventListener('click', function(e) {
        e.preventDefault();

        window.scrollTo({top: 0, behavior: 'smooth'});
    });

    var scrollTimeout;

    const callback = function() {
        if (scrollTimeout) {
            clearTimeout(scrollTimeout);
            scrollTimeout = null;
        }
        scrollTimeout = setTimeout(activeButtonBack, 50);
    }

    window.addEventListener('resize', activeButtonBack);
    window.addEventListener('scroll', activeButtonBack);
}

/**
 * Чекбоксы в виде звезд
 */
export const startCheckbox = () => {
    // TODO пока не делаю, проверить нужно ли
    // obj.addTrigger('mouseenter', '.js-checkbox-star', function(e) {
    //     var indexItem = $(this).index();

    //     $(this).parent().addClass('active-star-' + indexItem);
    // });

    // obj.addTrigger('mouseleave', '.js-checkbox-star', function(e) {
    //     $(this).parent().attr('class', 'Form__checkbox-star-list');
    // });

    // obj.addTrigger('click', '.js-checkbox-star label', function(e) {
    //     e.preventDefault();

    //     var parentBlock = $(this).parents('.Form__checkbox-star-list');
    //     var indexStar = $(this).parent().index() + 1;

    //     // Сбрасываем ранее выбранное кол-во звезд
    //     parentBlock.find('.js-checkbox-star .js-checkbox-item-star').prop('checked', false);

    //     if (parentBlock.attr('data-selected-star') == indexStar) {
    //         return false;
    //     } else {
    //         parentBlock.attr('data-selected-star', indexStar);

    //         for (var i = 0; i < indexStar; i++) {
    //             $(parentBlock.find('.js-checkbox-star .js-checkbox-item-star')[i]).prop('checked', true);
    //         }
    //     }
    // });
}

/**
 * Скроллим к элементу на странице
 */
export const scrollTo = (el, time = 250, offset_diff = 0) => {
    const $el = document.querySelector(el);
    time = time ? time : 250;

    if (!$el) {
        throw new Error('Элемент для скролла не найден: ' + el);
    } else {
        function smoothScrollTo(endScrollTop, duration) {
            let startScrollTop = window.pageYOffset;
            let startTime = null;
        
            function animationStep(timestamp) {
                if (!startTime) startTime = timestamp;
                let progress = timestamp - startTime;
                let percent = Math.min(progress / duration, 1);
                let newScrollTop = startScrollTop + (endScrollTop - startScrollTop) * percent;
                window.scrollTo(0, newScrollTop);
        
                if (progress < duration) {
                    requestAnimationFrame(animationStep);
                }
            }
        
            requestAnimationFrame(animationStep);
        }

        const targetScrollTop = $el.getBoundingClientRect().top + window.pageYOffset + offset_diff;

        // Плавно скроллим к целевой позиции
        smoothScrollTo(targetScrollTop, time);
    }
}

/**
 * Плавная прокрутка до элемента
 * @param  {Element} $el     Элемент
 * @param  {Object}  options Параметры:
 *                           {
 *                               time: 1.0,  // время анимации в секундах
 *                               fps: 60,    // "кадры" в секунду
 *                               offsetY: 0, // отступ сверху
 *                           }
 * @return {Promise} Промис по завершении анимации (reject при прерывании)
 */
export const scrollToElement = ($el, options = {}) => {
    if (!$el) {
        return Promise.reject();
    }

    return new Promise((resolve, reject) => {
        const time    = parseFloat(options.time)      || 1.0;
        const fps     = parseInt(options.fps, 10)     || 60;
        const offsetY = parseInt(options.offsetY, 10) || 0;

        const top = (function($el, y = 0) {
            do {} while (y += $el.offsetTop, $el = $el.offsetParent);
            return y;
        })($el);

        const from            = window.scrollY;
        const ticks           = time * fps;
        const distance        = Math.abs(from - top + offsetY);
        const distancePerTick = distance / ticks;
        let interval;

        // прокрутка не требуется
        if (!distance) {
            resolve();
        }

        function _interruptOnScroll() {
            if (window.scrollY != lastY) {
                _done(false);
            }
        }

        function _done(state) {
            if (interval) {
                clearInterval(interval);
            }
            window.removeEventListener('scroll', _interruptOnScroll);

            if (state) {
                resolve();
            } else {
                reject();
            }
        }

        window.addEventListener('scroll', _interruptOnScroll);

        // import BezierEazing from 'bezier-easing';
        const easing = BezierEazing(0.25, 0.1, 0.25, 1.0);
        let lastY    = from;
        let tick     = 0;
        function _loop() {
            if (++tick >= ticks) {
                _done(true);
                return;
            }

            lastY = Math.round(from - easing(distancePerTick * tick / distance) * distance);
            window.scroll(0, lastY);
        }

        interval = setInterval(_loop, 1000 / fps);
    });
}

/**
 * Функция для отложенного вызова другой функции
 */
export const throttle = (func, timeout) => {
    let inThrottle = false;

    return function() {
        const args = arguments;
        const context = this;

        if (!inThrottle) {
            inThrottle = true;
            func.apply(context, args);
            setTimeout(() => {
                inThrottle = false;
            }, timeout);
        }
    };
}

export const debounce = (func, timeout) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

/**
 * Установка/удаление cookie
 */
export const setCookie = (name, value, days) => {
    let expires = "";

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }

    document.cookie = name + "=" + (value || "") + expires + "; domain=.privettur.ru; path=/";
}

/**
 * Получаем cookie
 */
export const getCookie = (name) => {
    let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

export const hasTouristOrderCookie = () => /(?:^|;\s*)order_\d+_\d+=/.test(document.cookie || '');

export const hasAuthCookie = () => /(?:^|;\s*)(?:lk_user|user)\d+=/.test(document.cookie || '');

export const isStaff = () => /^[0-9]+:[a-f0-9]{32}$/.test(getCookie('adm') || '');

export const shouldShowBookingCounterFromCookie = () => hasTouristOrderCookie() && !hasAuthCookie();

/**
 * Кнопки «Избранное» / «Мои поездки» в шапке — только иконка, подпись в title.
 */
export const normalizeNewHeaderIconOnlyCounter = ($counter, title) => {
    if (!$counter || $counter.classList.contains('Nav__item')) {
        return;
    }

    $counter.classList.add('New-header__counter--iconOnly');

    if (title) {
        $counter.setAttribute('title', title);
    }

    $counter.querySelectorAll(':scope > span').forEach(($span) => {
        if ($span.classList.contains('New-header__counter-icon')) {
            return;
        }

        $span.remove();
    });
};

/**
 * Отмечаем избранное
 */
export const checkFavoriteList = () => {
    const favorite_list = getCookie('favorite_list');

    document.querySelectorAll('.js-objectFavorite[data-id]').forEach($favorite => {
        const $icons = $favorite.querySelectorAll('svg');

        if ($icons.length > 1) {
            $icons[1].classList.add('fade-out');
        }
    });
    
    if (typeof favorite_list === 'undefined') return;
    const hotel_list = JSON.parse(favorite_list).map(id => parseInt(id, 10));

    // отмечаем
    document.querySelectorAll('.js-objectFavorite[data-id]').forEach((el) => {
        const hotel_id = parseInt(el.dataset.id, 10);
        const $icons = el.querySelectorAll('svg');

        if (hotel_list.indexOf(hotel_id) > -1) {
            el.classList.add('active');

            if ($icons.length > 1) {
                $icons[1].classList.replace('fade-out', 'fade-in-reduce');
            }
        }
    })

    // обновляем счётчик избранного
    updateFavorites(hotel_list.length);
}

/**
 * Ставим куку поддержки webp или нет
 */
export const setWebpSupportCookie = () => {
    let elem = document.createElement('canvas');
    let support = false;

    if (!!(elem.getContext && elem.getContext('2d'))) {
        // was able or not to get WebP representation
        support = elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;

    }

    if (support === true) {
        setCookie('webp_support', 1, 365);
    } else {
        setCookie('webp_support', 0, 365);
    }

    // very old browser like IE 8, canvas not supported
    return support;
}

/**
 * Определяем поддержку webp по кукам
 */
export const hasWebpSupport = () => {
    let webp_support = getCookie('webp_support');

    // нет куки, проверяем поддержку webp
    if (typeof webp_support === 'undefined' || webp_support.length === 0) {
        setWebpSupportCookie();
    }

    if (getCookie('webp_support') === '1') {
        return true;
    }

    return false;
}

/**
 * LazyLoad для iframe
 */
export const lazyFrame = ($element) => {
    $element = typeof $element === 'undefined' ? document.querySelectorAll('.js-lazyFrame') : $element;
    const lazyFrameOne = ($item) => {
        const frame     = $item.dataset.frame;
        const frameType = $item.dataset.frameType;

        if (frameType === 'html' && typeof frame === 'string' && frame.length > 0) {
            const $parent = $element.parentNode;

            const $div = document.createElement('div');
            $div.innerHTML = frame;
            const $iframe = $div.firstElementChild;
            $parent.appendChild($iframe);

            $iframe.addEventListener('load', () => {
                $element.remove();
                $iframe.style.display = '';
            });
        } else if (typeof frame === 'string' && frame.length > 0) {
            const $parent = $element.parentNode;

            const $div = document.createElement('div');
            $div.innerHTML = '<iframe src="' + frame + '" frameborder="0" allowfullscreen style="display: none;"></iframe>';
            const $iframe = $div.firstElementChild;
            $parent.appendChild($iframe);

            $iframe.addEventListener('load', () => {
                $element.remove();
                $iframe.style.display = '';
            });
        }
    }

    // массив
    if (typeof $element.length !== 'undefined') {
        $element.forEach($item => lazyFrameOne($item));
    } else {
        lazyFrameOne($element);
    }
}

/**
 * LazyLoad для css
 */
export const lazyClass = function($element) {
    $element = typeof $element === 'undefined' ? document.querySelectorAll('.js-lazyClass') : $element;
    const lazyClassOne = ($item) => {
        if (hasWebpSupport()) {
            $item.classList.add('webp');
        } else {
            $item.classList.add('original');
        }
    }

    // массив
    if (typeof $element.length !== 'undefined') {
        $element.forEach($item => lazyClassOne($item));
    } else {
        lazyClassOne($element);
    }
}

/**
 * LazyLoad для блоков
 */
export const lazyBlock = ($element) => {
    $element = typeof $element === 'undefined' ? document.querySelectorAll('.js-lazyBlock') : $element;
    const lazyBlockOne = ($item) => {
        // для отработки только 1 раз
        $item.classList.remove('js-lazyBlock');

        const callback = $item.dataset.callback;

        // есть callback
        if (callback) {
            // для отработки только 1 раз
            $item.dataset.callback = '';

            triggerEvent(callback, $item);
        }
    }

    // массив
    if (typeof $element.length !== 'undefined') {
        $element.forEach($item => lazyBlockOne($item));
    } else {
        lazyBlockOne($element);
    }
}

/**
 * LazyLoad всего
 */
export const lazyLoad = ($container) => {
    // если контейнера нет, значит observer неподдерживается, поэтому грузим все
    if ($container === null || typeof $container === 'undefined') {
        lazyClass();
        lazyBlock();
        lazyFrame();
    }

    // lazyClass
    if ($container.classList.contains('js-lazyClass')) {
        return lazyClass($container);
    }

    // lazyBlock
    if ($container.classList.contains('js-lazyBlock')) {
        return lazyBlock($container);
    }

    // lazyFrame
    if ($container.classList.contains('js-lazyFrame')) {
        return lazyFrame($container);
    }

    if (hasDebug() && typeof $container === null) {
        throw new Error('container не объявлен');
    }

    // fix slick copy init block
    $container.querySelectorAll(':not(img).js-lazyLoad.js-lazyLoadInit').forEach(($item) => {
        if ($item.querySelector('img') === null) {
            $item.classList.remove('js-lazyLoadInit');
        }
    });

    let $items = $container.querySelectorAll('.js-lazyLoad:not(.js-lazyLoadInit)');

    // есть ли смысл сортировать?
    if($items.length > 0 && $items[0].getAttribute('data-sort') !== null) {
        $items.sort(function(a, b) {
            return a.getAttribute('data-sort') > b.getAttribute('data-sort');
        });
    }

    // LazyLoad фоток
    $items.forEach($item => {
        const data = {
            src: $item.getAttribute('data-src'),
            srcset: $item.getAttribute('data-srcset'),
            webp_src: $item.getAttribute('data-webp-src'),
            webp_srcset: $item.getAttribute('data-webp-srcset'),
            alt: $item.getAttribute('data-alt'),
            style: $item.getAttribute('data-style'),
        };
        const imgAttr = {
            src: false,
            srcset: false,
            alt: false,
            style: false,
        };

        // отмечаем как просмотрено
        $item.classList.add('js-lazyLoadInit');

        // webp
        if(hasWebpSupport()
            && typeof data.webp_src !== 'undefined'
            && /.*.webp/.test(data.webp_src)) {

            // src
            imgAttr.src = data.webp_src;

            // srcset
            if(typeof data.webp_srcset !== 'undefined' && /.*.webp/.test(data.webp_srcset)) {
                imgAttr.srcset = data.webp_srcset;
            }
        } else {
            // src
            imgAttr.src = data.src;

            // srcset
            if(typeof $srcset !== 'undefined') {
                imgAttr.srcset = data.srcset;
            }
        }

        // style
        if(data.style !== null && data.style.length > 0) {
            imgAttr.style = data.style;
        }

        // alt
        if(data.alt !== null && data.alt.length > 0) {
            imgAttr.alt = data.alt;
        }

        // загрузка Image последовательно
        if($item.nodeName === 'IMG') {
            if (imgAttr.src) {
                $item.setAttribute('src', imgAttr.src);
            }

            if (imgAttr.style) {
                $item.setAttribute('style', imgAttr.style);
            }

            if (imgAttr.srcset) {
                $item.setAttribute('srcset', imgAttr.srcset);
            }

            if (imgAttr.alt) {
                $item.setAttribute('alt', imgAttr.alt);
            }
        } else {
            // ищем заглушку, если нет - создаём
            let $img = $item.querySelector('img');
            if ($img === null) {
                $img = document.createElement('img');
                $item.appendChild($img);
            }

            // применяем аттрибуты
            for (let field in imgAttr) {
                if (imgAttr[field]) {
                    $img.setAttribute(field, imgAttr[field]);
                }
            }
        }

        if($item.classList.contains('js-removeStyle')) {
            $item.removeAttribute('style');
        }
    });

    // любые элементы со style
    $container.querySelectorAll('.js-lazyLoadBlock:not(.js-lazyLoadInit)').forEach($item => {
        const $style = $item.getAttribute('data-style');
        const $webp_style = $item.getAttribute('data-webp-style');

        // отмечаем как просмотрено
        $item.classList.add('js-lazyLoadInit');

        if(hasWebpSupport()
            && typeof $webp_style !== 'undefined'
            && /.*.webp/.test($webp_style)) {
            $item.setAttribute('style', $webp_style);
            return true;
        }

        $item.setAttribute('style', $style);
    });
}

/**
 * Проверяем поддержку observer
 */
export const hasObserverSupport = () => {
    let hasObserver = getCookie('observer_support');

    // нет куки
    if (typeof hasObserver === 'undefined') {
        if (!'IntersectionObserver' in window ||
            !'IntersectionObserverEntry' in window ||
            !'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
            setCookie('observer_support', 0, 365);
            return false;
        } else {
            setCookie('observer_support', 1, 365);
            return true;
        }
    }

    return hasObserver == 1 ? true : false;
}

/**
 * Инициализация обсервера
 */
export const initObserver = function() {
    if (hasObserverSupport()) {
        // обсервер для lazyLoad
        const intersectionObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(item) {
                if (item.isIntersecting === true) {
                    lazyLoad(item.target);
                }
            });
        });

        let containerList = [];
            containerList = Array.prototype.concat.apply(containerList, document.getElementsByClassName('js-lazyLoadContainer'));
            containerList = Array.prototype.concat.apply(containerList, document.getElementsByClassName('js-lazyClass'));
            containerList = Array.prototype.concat.apply(containerList, document.getElementsByClassName('js-lazyBlock'));
            containerList = Array.prototype.concat.apply(containerList, document.getElementsByClassName('js-lazyFrame'));

        for (let item of containerList) {
            if (item.classList.contains('js-initObserver')) {
                continue;
            }

            item.classList.add('js-initObserver');
            intersectionObserver.observe(item);
        }
    } else {
        if(document.readyState !== 'loading') {
            lazyLoad()
        } else {
            window.addEventListener('DOMContentLoaded', lazyLoad);
        }
    }
}

/**
 * Инициализация обсервера
 */
export const lazyLoadBlock = function($block, callback) {
    if (!$block) {
        return;
    }

    if (hasObserverSupport()) {
        // обсервер для lazyLoad
        const intersectionObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(item) {
                if (item.isIntersecting === true) {
                    callback($block);
                }
            });
        });

        intersectionObserver.observe($block);
    } else {
        if(document.readyState !== 'loading') {
            callback($block);
        } else {
            window.addEventListener('DOMContentLoaded', () => {
                callback($block);
            });
        }
    }
}

/**
 * Глобальный IntersectionObserver
 * @param  Array|NodeList|ObjectList options.elements Массив элементов
 * @param  Object                    options.options  Объект с опциями для IntersectionObserver (root, threshold, rootMargin)
 * @param  Function                  options.callback Функция которая вызывается после срабатывания
 */
export const observe = ({elements, options, callback}) => {
    // TODO
    // if (typeof elements == 'undefined') {
    //     return false;
    // }

    // if (typeof elements == 'object' && elements.nodeType) {
    //     elements = [elements];
    // }

    // // по умолчанию вызывается lazyLoad
    // if (typeof callback != 'function') {
    //     callback = function(elements) {
    //         elements.forEach(function(element) {
    //             obj.lazyLoad($(element));
    //         });
    //     }
    // }

    // // не поддерживается
    // if (!obj.hasObserverSupport()) {
    //     callback(Array.from(elements));
    //     return false;
    // }

    // const observer = new IntersectionObserver(function(entries) {
    //     const intersected = entries.filter(function(entry) {
    //         return entry.isIntersecting;
    //     });

    //     intersected.forEach(function(entry) {
    //         observer.unobserve(entry.target);
    //     });

    //     if (intersected.length) {
    //         callback(intersected.map(function(entry) {
    //             return entry.target;
    //         }));
    //     }
    // }, options);

    // // вешаем слушателя
    // Array.from(elements).forEach(function(element) {
    //     observer.observe(element);
    // });
}

/**
 * Отправляем просмотры
 */
export const hotelViewSender = () => {
    window.hotelShowSenderHandle = typeof window.hotelShowSenderHandle === 'undefined' ? false : window.hotelShowSenderHandle;
    window.hotelShowList         = typeof window.hotelShowList === 'undefined' ? [] : window.hotelShowList;
    window.hotelShowListSended   = typeof window.hotelShowListSended === 'undefined' ? [] : window.hotelShowListSended;
    window.needToSend            = typeof window.needToSend === 'undefined' ? [] : window.needToSend;

    if (window.hotelShowList.length === 0 || window.hotelShowList.length === window.hotelShowListSended.length) {
        return false;
    }

    clearTimeout(window.hotelShowSenderHandle);
    window.hotelShowSenderHandle = setTimeout(function () {
        // смотрим что нужно отправить
        window.hotelShowList.forEach(function(id) {
            if (window.hotelShowListSended.indexOf(id) === -1) {
                window.needToSend.push(id);
            }
        });

        // копируем массив
        window.hotelShowListSended = JSON.parse(JSON.stringify(window.hotelShowList));

        fetch('/hotels/increment_hotels_shows/', {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData({
                'hotel_list[]': window.needToSend,
                'page_type_id': document.body.dataset.page_type_id || 0,
            }),
        });

        if (window.needToSend) {
            const ecommerceItems = [];

            [...window.needToSend].forEach(hotelID => {
                const $cardData = document.querySelector('#hotel-' + hotelID + ' > script');
                if ($cardData) {
                    let json;

                    try {
                        json = JSON.parse($cardData.innerHTML)
                    } catch(e) {
                        console.error(e);
                    }

                    if (json) {
                        ecommerceItems.push(json);
                    }

                    // вешаем событие на клик
                    const $card = document.querySelector('#hotel-' + hotelID);
                    if ($card && json) {
                        $card.addEventListener('click', (e) => {
                            YandexEcommerce.push('click', [json]);
                        });
                    }
                }
            });

            if (ecommerceItems.length > 0) {
                YandexEcommerce.push('impressions', ecommerceItems);
            }
        }

        window.needToSend = [];
    }, 1000);
}

/**
 * Добавляем обсерверы на отели
 */
export const updateHotelViewObserver = () => {
    // поддержка обсерверов
    if (!hasObserverSupport()) {
        return false;
    }

    window.hotelShowList = typeof window.hotelShowList === 'undefined' ? [] : window.hotelShowList;

    // обсервер для просмотров объектов
    const hotelViewObserver = new IntersectionObserver(function(entries) {
        let isFired = false;
        entries.forEach(function(item) {
            if (item.intersectionRatio > 0) {
                let id = parseInt(item.target.dataset.id, 10);
                if (window.hotelShowList.indexOf(id) === -1) {
                    window.hotelShowList.push(id);
                }
                isFired = true;
            }
        });

        // задачу на отправку
        if (isFired) {
            hotelViewSender();
        }
    });

    const containerList = document.querySelectorAll('.js-objectFavorite:not(.js-hotelViewObserverInit)');
    for (var i = 0; i < containerList.length; i++) {
        containerList[i].classList.add('js-hotelViewObserverInit');
        hotelViewObserver.observe(containerList[i]);
    }
}

/**
 * Скрипт анимации прелоадера - логотипа
 */
export const animateSvgPre = (abort) => {
    let svgPre = document.querySelectorAll('.js-preloadNew path:not(:first-child)');
    let arrOpacity = [];
    let intervalID = '';

    let i = 0;
    [].forEach.call(svgPre, function(el) {
        let x = el.getAttribute('fill-opacity');
        arrOpacity.push(x);
    });

    if(abort) {
        clearInterval(intervalID);
        return false;
    }

    intervalID = setInterval(function() {
        // Пересобираем массив
        arrOpacity = [arrOpacity[arrOpacity.length - 1], ...arrOpacity];
        delete arrOpacity[arrOpacity.length - 1];
        arrOpacity = arrOpacity.filter(function(index) {
            return index !== 'undefined';
        });

        arrOpacity.forEach(function(val) {
            svgPre[i].setAttribute('fill-opacity', val);

            i++;

            if (i == arrOpacity.length) {
                i = 0;
            }
        });

    }, 130);
}

/**
 * Кроссбраузерная Функция для получения объекта глобальных координат отступа
 */
export const getViewportOffset = () => {
    return {
        top: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop,
        left: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft
    };
}

/**
 * Аналог observer только нативный
 */
export const isScrolledIntoView = (elem) => {
    const docViewTop = window.pageYOffset,
          docViewBottom = docViewTop + window.innerHeight,
          elemTop = elem.offsetTop,
          elemBottom = elemTop + elem.offsetHeight;
    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

/**
 * Установка фокуса на последний символ поля elem
 */
export const setCaretAtEnd = (elem) => {
    var elemLen = elem.value.length;
    // For IE Only
    if (document.selection) {
        // Set focus
        elem.focus();
        // Use IE Ranges
        var oSel = document.selection.createRange();
        // Reset position to 0 & then set at end
        oSel.moveStart('character', -elemLen);
        oSel.moveStart('character', elemLen);
        oSel.moveEnd('character', 0);
        oSel.select();
    } else if (elem.selectionStart || elem.selectionStart == '0') {
        // Firefox/Chrome
        elem.selectionStart = elemLen;
        elem.selectionEnd = elemLen;
        elem.focus();
    }
}

/**
 * Вспомогательная функция для парсинга url
 */
export const parseUrl = () => {
    let search = location.hash;
    let parse = {};

    if (search.length > 1) {
        search = search.replace('#', '');
        try {
          parse = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}', function(key, value) { return key===""?value:decodeURIComponent(value) })
        } catch(e) {
            // ignore
            parse = {}
        }
    }

    return parse;
}

export const consoleTime = (label) => {
    if (hasDebug()) {
        console.time(label);
    }
}

export const consoleTimeEnd = (label) => {
    if (hasDebug()) {
        console.timeEnd(label);
    }
}

/**
 * Функция склонения
 */
export const declension = function(count, f1, f24, f50) {
    count = parseInt(count, 10);
    if(count > 10 && count < 20) {
        return f50;
    }
    if(count % 10 == 1) {
        return f1;
    }
    if(count % 10 == 2 || count % 10 == 3 || count % 10 == 4) {
        return f24;
    }
    return f50;
}

/**
 * Загружаем первые фотки для скелета
 * $container контейнер с фотками
 * deferredCount минимальное число фоток, которое надо загрузить
 */
export const loadFirstImages = ($container, deferredCount = 6) => {
    return new Promise((resolve, reject) => {
        // контейнер пуст или кол-во объектов не указано
        if ($container === null || deferredCount <= 0) {
            return resolve(false);
        }

        // контейнеры для фотогалереи карточек
        const $photoContainers = $container.querySelectorAll('.js-photoContainer');

        if ($photoContainers.length === 0) {
            return resolve(false);
        }

        // кол-во объектов на странице может быть меньше deferredCount
        if ($photoContainers.length < deferredCount) {
            deferredCount = $photoContainers.length;
        }

        const count = deferredCount;
        for (var i = 0; i < count; i++) {
            console.log($photoContainers[i]);
            // const json = $photoContainers[i].data('photo-json');

            // // нет данных
            // if (typeof json === 'undefined' || $photoContainer.length === 0 ||
            //     typeof json[0] === 'undefined' || typeof json[0]['photo'] === 'undefined') {
            //     continue;
            // }
            // const src        = json[0]['photo'];
            // const $imageItem = $('.js-image', $photoContainer);
            // obj.loadImage(src).then(function() {
            //     $imageItem.css('background-image', 'url(' + src + ')');
            //     deferredCount--;
            //     if (deferredCount === 0) {
            //         deferred.resolve();
            //     }
            // });
        }
    });
}

/**
 * Загрузка изображений
 * Возвращает Promise, который срабатывает, после загрузки фото
 */
export const loadImage = (src) => {
    // TODO
    // const deferred = $.Deferred();
    // const image    = new Image();

    // // повторное обращение
    // if (obj.page.images.hasOwnProperty(src)) {
    //     return deferred.resolve();
    // }

    // // фотка успешно загружена
    // $(image).load(function(e) {
    //     deferred.resolve();
    //     obj.page.images[src] = image;
    // });

    // // ошибка
    // $(image).error(function(e) {
    //     deferred.resolve();
    //     obj.page.images[src] = image;
    // });

    // image.src = src;

    // return deferred;
}

/**
 * Загрузка всех изображений
 * Возвращает Promise, который срабатывает, после загрузки всех фото
 */
export const loadImages = (srcList) => {
    if (!srcList || !Array.isArray(srcList)) {
        return;
    }

    let count = srcList.length;

    return new Promise((resolve, reject) => {
        srcList.forEach(item => {
            let img     = new Image();
            img.onload  = () => {
                count--;
                if (count === 0) {
                    resolve();
                }
            };
            img.onerror = (err) => console.log(err);
            img.src     = item['photo'];
        });
    });
}

/**
 * detect if localStorage is supported
 */
export const checkLocalStorage = () => {
    let mod = '1';
    try {
        localStorage.setItem(mod, mod);
        localStorage.removeItem(mod);
        return true;
    } catch(e) {
        return false;
    }
}

/**
 * AJAX загрузка HTML блоков
 *
 * @data lazy_block PHP Идентификатор блока ({$block_name})
 *
 * TODO: Вынести в компонент
 */
export const dataLazyLoad = () => {
    const $lazyBlock = document.querySelectorAll('[data-lazy_block]:not(.is-loading)');
    if ($lazyBlock.length === 0) {
        return;
    }

    function loadBlock($block) {
        let $parent = $block.parentNode;

        // от повторных вызовов
        $block.classList.add('is-loading');

        // имя блока
        const lazy_block = $block.dataset.lazy_block,
              url        = $block.dataset.url || window.location.pathname,
              data       = $block.dataset.data || [];

        const formData = new FormData();
        formData.append('element', lazy_block);
        formData.append('data', data);

        fetch(url, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
        })
        .then(response => response.json())
        .then(r => {
            $block.classList.remove('is-loading');
            if (r.status == 'ok') {
                $block.outerHTML = r.html.trim();
                $block.style.opacity = 0;
                $block.style.display = '';

                if (lazy_block) {
                    triggerEvent('lazy_block', {
                        name: lazy_block,
                        $element: $block,
                        $parent: $parent,
                        data: r.data || {}
                    });
                }
            } else if (r.status == 'error') {
                $block.parentNode.removeChild($block);
            }
        });
    }

    if (hasObserverSupport()) {
        // обсервер для lazyLoad
        const observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(item) {
                if (item.isIntersecting === true) {
                    loadBlock(item.target);
                    observer.unobserve(item.target)
                }
            });
        });

        $lazyBlock.forEach(function($block) {
            // использование observer
            if (!('observer' in $block.dataset) || $block.dataset.observer == 'true') {
                observer.observe($block);
            } else {
                loadBlock($block);
            }
        });
    } else {
        if(document.readyState !== 'loading') {
            $lazyBlock.forEach(loadBlock);
        } else {
            window.addEventListener('DOMContentLoaded', function() {
                $lazyBlock.forEach(loadBlock);
            });
        }
    }
}

/**
 * Общий метод сохранения данных
 */
export const saveData = (name, value, arrName = '') => {
    if (typeof window.storage === 'undefined') {
        window.storage = {};
    }

    if (arrName.length >= 0) {
        if (typeof window.storage[arrName] === 'undefined') {
            window.storage[arrName] = {};
        }
        return window.storage[arrName][name] = value;
    }

    return window.storage[name] = value;
}

/**
 * Общий метод сохранения данных
 */
export const getData = (name, arrName = '') => {
    if (typeof window.storage === 'undefined') {
        window.storage = {};
    }

    if (arrName.length >= 0) {
        if (typeof window.storage[arrName] === 'undefined') {
            window.storage[arrName] = {};
        }
        return window.storage[arrName][name];
    }

    return window.storage[name];
}

/**
 * Задержка для callback, чтобы не спамить запросами
 */
export const delay = (callback, ms) => {
    window.delayTimer = typeof window.delayTimer === 'undefined' ? 0 : window.delayTimer;
    clearTimeout(window.delayTimer);
    window.delayTimer = setTimeout(function() {
        callback();
    }, ms || 0);
}

/**
 * Задержка для callback, чтобы не спамить запросами
 */
export const freeze = (callback, ms) => {
    if (window.freezeCalled === true) {
        return false;
    }
    window.freezeCalled = true;

    setTimeout(function() {
        window.freezeCalled = false;

        callback();
    }, ms || 0);
}

/**
 * Аналог Object.assign только работает везде
 */
export function collectObjects() {
    let ret = {};

    for (let i = 0; i < arguments.length; i++) {
        for (const p in arguments[i]) {
            if (arguments[i].hasOwnProperty(p)) {
                ret[p] = arguments[i][p];
            }
        }
    }

    return ret;
}

/**
 * Преобразуем args в FormData
 */
export const formData = (args) => {
    const formData = new FormData();

    for (const p in args) {
        if (args.hasOwnProperty(p)) {
            formData.append(p, args[p]);
        }
    }

    return formData;
}

/**
 * Преобразуем args в FormData
 */
export const escapeHtml = (unsafe) => {
    return unsafe
         .replace(/&/g, "&amp;")
         .replace(/</g, "&lt;")
         .replace(/>/g, "&gt;")
         .replace(/"/g, "&quot;")
         .replace(/'/g, "&#039;");
}

// гугловский метод сериализации
export const serialize = (form) => {
    if (!form || form.nodeName !== "FORM") {
        return
    }
    var i, j, q = [];
    for (i = form.elements.length - 1; i >= 0; i = i - 1) {
        if (form.elements[i].name === "") {
            continue
        }
        switch (form.elements[i].nodeName) {
            case "INPUT":
                switch (form.elements[i].type) {
                    case "text":
                    case "hidden":
                    case "password":
                    case "button":
                    case "reset":
                    case "submit":
                        q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
                        break;
                    case "checkbox":
                    case "radio":
                        if (form.elements[i].checked) {
                            q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value))
                        }
                        break;
                    case "file":
                        break
                }
                break;
            case "TEXTAREA":
                q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
                break;
            case "SELECT":
                switch (form.elements[i].type) {
                    case "select-one":
                        q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
                        break;
                    case "select-multiple":
                        for (j = form.elements[i].options.length - 1; j >= 0; j = j - 1) {
                            if (form.elements[i].options[j].selected) {
                                q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].options[j].value))
                            }
                        }
                        break
                }
                break;
            case "BUTTON":
                switch (form.elements[i].type) {
                    case "reset":
                    case "submit":
                    case "button":
                        q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
                        break
                }
                break
        }
    }
    return q.join("&")
};

/**
 * Преобразуем args в FormData
 */
export const getDataFormatter = (args) => {
    const formData = new FormData();
    let str        = '';
    for (let p in args) {
        if (!args.hasOwnProperty(p)) {
            continue;
        }

        if (str != '') {
            str += '&';
        }

        if (Array.isArray(args[p])) {
            args[p].forEach(value => {
                formData.append(p + '[]', encodeURIComponent(value))
            });
        } else {
            formData.append(p, encodeURIComponent(args[p]));
        }
    }

    return formData;
}

/**
 * Запуск таймера, исправляющего (помогающего исправлять) поведение страниц на некоторых браузерах
 */
export const initFallbackStyles = () => {
    // принудительный пересчёт высоты экрана
    setInterval(function() {
        const vh = parseFloat((window.innerHeight * 0.01).toFixed(2));
        if (vh != parseFloat(document.documentElement.style.getPropertyValue('--vh'))) {
            document.documentElement.style.setProperty('--vh', vh + 'px');
        }
    }, 100);
}

/**
 * Переключение избранного
 */
export const switchFavorite = ($button) => {
    const id = +$button.dataset.id || 0;
    let favorite_list = getCookie('favorite_list');
        favorite_list = typeof favorite_list === 'undefined' ? [] : JSON.parse(favorite_list);
    const index = favorite_list.indexOf(id);
    let isActive = index > -1 ? true : false;

    // элемент в массиве - удаляем
    if (isActive) {
        favorite_list.splice(index, 1);
    }

    // снимаем выбранное избранное
    document.querySelectorAll(`.js-objectFavoriteHotel[data-id="${id}"]`).forEach($item => $item.classList.toggle('active', !isActive));

    const $icons = $button.querySelectorAll('svg');

    if ($icons.length > 1) {
        const $icon = $icons[1];
    
        $icon.style.display = 'block';
        if ($icon.classList.contains('fade-out')) {
            $icon.classList.replace('fade-out', 'fade-in')
            setTimeout(() => $icon.classList.replace('fade-in', 'fade-in-reduce'), 400);
        } else if ($icon.classList.contains('fade-in-reduce')) {
            $icon.classList.replace('fade-in-reduce', 'fade-out');
        } else {
            $icon.classList.add('fade-out');
        }
    }

    // переключаем избранное
    $button.classList.toggle('active', !isActive);
    if($button.classList.contains('active')) {
        favorite_list.push(id);
    }

    // меняем текст на кнопке в карточке объекта
    if ($button.classList.contains('js-objectFavoriteHotel') && !$button.classList.contains('js-mobile')) {
        if ($button.classList.contains('active')) {
            $button.textContent = 'Сохранено';
        } else {
            $button.textContent = 'Сохранить';
        }
    }

    // сохраняем
    setCookie('favorite_list', JSON.stringify(favorite_list), 365);

    // обновляем счётчик избранного
    updateFavorites(favorite_list.length);
}

/**
 * Безопасный парсинг JSON
 * @param  {String} data         JSON валидный текст
 * @param  {Mixed}  defaultValue Значение заглушка
 * @return {Mixed}
 */
export const safeJSONParse = (data, defaultValue = []) => {
    try {
        return JSON.parse(data);
    } catch (e) {
        return defaultValue;
    }
}

/**
 * Определение мобилки
 * @return {Boolean}
 */
export const isMobile = () => {
    if (typeof document.body.dataset.is_mobile == 'undefined') {
        return window.innerWidth <= 959;
    }

    return Boolean(parseInt(document.body.dataset.is_mobile, 10));
};

/**
 * Проверка на Apple продукцию
 * @return {Boolean} true если Apple
 */
export const isApple = function() {
    if (typeof window._isApple != 'undefined') {
        return window._isApple;
    }

    return window._isApple = [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
    ].includes(navigator.platform) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
}

/**
 * Создание элемента из строки
 * @param  {String} html      HTML валидный текст
 * @return {ELement|Array} Элемент или Массив
 */
export const createElement = function(html) {
    // Удаляем комментарии из HTML
    html = html.replace(/<!--[\s\S]*?-->/g, '').trim();
    
    const template = document.createElement('template');
    template.insertAdjacentHTML('afterbegin', html);
    return template.children.length > 1 ? [...template.children] : template.firstElementChild;
}

export const disableScroll = function (args = {}) {
    const $header = document.querySelector('.js-header');

    let {isDisabled, useHeader} = {
        isDisabled: typeof args.isDisabled === undefined ? true : args.isDisabled,
        useHeader: typeof args.useHeader === undefined ? true : args.useHeader,
    }

    if (isDisabled) {
        document.body.style.setProperty('padding-right', window.innerWidth - document.body.clientWidth + 'px');
        if ($header !== null && useHeader) {
            $header.style.setProperty('padding-right', window.innerWidth - document.body.clientWidth + 'px');
        }
    } else {
        document.body.style.setProperty('padding-right', '');
        if ($header !== null && useHeader) {
            $header.style.setProperty('padding-right', '');
        }
    }

    document.body.classList.toggle('modal-active', isDisabled);
}

export const generateHash = function (length = 256) {
    let result           = '';
    let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
   }

   return result;
}

export const firstUpper = function (str) {
    return str.substring(0, 1).toUpperCase() + str.substring(1);
}

export const isPlainObject = function (obj) {
    let proto, Ctor;

    let class2type = {};

    let toString = class2type.toString;

    let hasOwn = class2type.hasOwnProperty;

    let fnToString = hasOwn.toString;

    let ObjectFunctionString = fnToString.call( Object );

    // Detect obvious negatives
    // Use toString instead of jQuery.type to catch host objects
    if (!obj || toString.call(obj) !== "[object Object]") {
        return false;
    }

    proto = Object.getPrototypeOf(obj);

    // Objects with no prototype (e.g., `Object.create( null )`) are plain
    if (!proto) {
        return true;
    }

    // Objects with prototype are plain iff they were constructed by a global Object function
    Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
    return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
}

export const copyToClipboard = function (text) {
    if (window.clipboardData && window.clipboardData.setData) {
        // IE specific code path to prevent textarea being shown while dialog is visible.
        return clipboardData.setData("Text", text);

    } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        let textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";
        document.body.appendChild(textarea);
        textarea.select();

        try {
            return document.execCommand("copy");  // Security exception may be thrown by some browsers.
        } catch (ex) {
            return false;
        } finally {
            document.body.removeChild(textarea);
        }
    }
}

export const observeElement = function ($elem, callback, options = {}) {
    callback = typeof callback === 'function' ? callback : () => {};

    if (hasObserverSupport()) {
        // обсервер для lazyLoad
        const observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(item) {
                if (item.isIntersecting === true) {
                    callback(item.target);

                    observer.unobserve($elem);
                }
            });
        }, options);

        // использование observer
        if (!('observer' in $elem.dataset) || $elem.dataset.observer == 'true') {
            observer.observe($elem);
        } else {
            callback();
        }
    } else {
        if(document.readyState !== 'loading') {
            callback($elem);
        } else {
            window.addEventListener('DOMContentLoaded', function() {
                callback($elem);
            });
        }
    }
}

// аналог $el.height()
export const height = function ($elem) {
    if (!$elem) {
        return 0;
    }

    return parseFloat(window.getComputedStyle($elem, null).height.replace("px", ""));
}

// вызывает метрику пока она не появится
export const checkGA = function (callback) {
    if (typeof callback !== 'function') {
        callback = function(){};
    }

    if (typeof ga === 'function') {
        if (typeof callback === 'function') {
            callback();
        }
    } else {
        setTimeout(function() {
            checkGA(callback);
        }, 500);
    }
}

export const asBoolean = function (value) {
    if (typeof value == 'undefined') {
        return false;
    }

    switch (value.toString().toLowerCase().trim()) {
        case 'false':
        case 'off':
        case 'no':
        case '0':
        case '':
            return false;
    }

    return Boolean(value);
}

/**
 * Положение элемента на экране
 * @param  {HTMLElement} $el Элемент
 * @param  {Number}      x   Начальная позиция по X
 * @param  {Number}      y   Начальная позиция по Y
 * @return {Object}          {x, y, top: y, left: x}
 */
export const getElementOffset = function($el, x = 0, y = 0) {
    while (x += $el.offsetLeft, y += $el.offsetTop, $el = $el.offsetParent) {}
    return {x, y, top: y, left: x};
}

/**
 * Суммарное значение скролла элемента и его родителей
 * @param  {HTMLElement} $el Элемент
 * @param  {Number}      x   Начальная позиция по X
 * @param  {Number}      y   Начальная позиция по Y
 * @return {Object}          {x, y, top: y, left: x}
 */
export const getElementScrollOffset = function($el, x = 0, y = 0) {
    while ($el && $el.offsetParent) {
        x += $el.offsetParent.scrollLeft;
        y += $el.offsetParent.scrollTop;
        $el = $el.offsetParent;
    }

    if (window.getComputedStyle($el).position == 'fixed') {
        x -= window.pageXOffset;
        y -= window.pageYOffset;
    }

    return {x, y, top: y, left: x};
}

/**
 * Продолжительность выполнения анимации
 * @param  {Element} $el  Проверяемый элемент
 * @param  {String}  name Имя анимируемого свойства
 * @return {Number}       Время анимации в милисекундах
 */
export const getTransitionDuration = function($el, name) {
    const transition = (window.getComputedStyle($el).transition || 'all 0s ease 0s').split(',').map(s => s.trim()).reduce((acc, item) => {
        const [property, duration, timingFunction, delay] = item.split(' ');

        acc[property] = {
            duration: parseFloat(duration) * 1000,
            timingFunction,
            delay: parseFloat(delay) * 1000,
        }

        return acc;
    }, {});

    // имя не передано = любой самый долгий переход
    if (typeof name == 'undefined') {
        const timings = [];
        for (const key in transition) {
            timings.push(transition[key].duration + transition[key].delay);
        }
        return Math.max.apply(null, timings);
    }

    // имя передано = поиск по имени либо "все"
    if (transition[name]) {
        return transition[name].duration + transition[name].delay;
    } else if (transition['all']) {
        return transition['all'].duration + transition['all'].delay;
    }

    return 0;
}

/**
 * Замена элемента другим
 * @param  {HTMLElement} $replace Заменяемый элемент
 * @param  {HTMLElement} $with    Замещающий элемент
 * @return {HTMLElement} $with
 */
export const replaceElementWith = function($replace, $with) {
    $replace.insertAdjacentElement('beforebegin', $with);
    $replace.parentElement.removeChild($replace);
    return $with;
}

export const parents = function(el, selector) {
    const parents = [];
    while ((el = el.parentNode) && el !== document) {
        if (!selector || el.matches(selector)) {
            parents.unshift(el);
        }
    }

    return parents;
}

/**
 * Автоматическое обновление высоты поля ввода TEXTAREA в зависимости от количества строк
 * @param  {Element} $textarea Поле ввода
 * @param  {Object}  options   Параметры
 * @return {Object}            Объект с функцией off для отключения
 */
export const autoUpdateTextareaHeight = ($textarea, options = {}) => {
    const _options = Object.assign({
        rowsMin: $textarea.rows, // минимальное количество строк, если не указано берётся автоматически
    }, options);

    const updater = ($textarea) => {
        $textarea.rows = Math.max(_options.rowsMin, $textarea.value.split(/\n/).length);
    }
    const updaterBound = updater.bind(null, $textarea);

    $textarea.addEventListener('input', updaterBound);
    window.requestAnimationFrame(updaterBound);

    return {
        update: updaterBound,
        off: () => {
            $textarea.removeEventListener('input', updaterBound);
        },
    }
};

/**
 * RGBA to hex
 * @see https://stackoverflow.com/questions/1740700/how-to-get-hex-color-value-rather-than-rgb-value
 * @param  {String} rgba
 * @return {String}
 */
export const rgba2hex = (rgba) => `#${rgba.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.{0,1}\d*))?\)$/).slice(1).map((n, i) => (i === 3 ? Math.round(parseFloat(n) * 255) : parseFloat(n)).toString(16).padStart(2, '0').replace('NaN', '')).join('')}`

/**
 * Форматирование даты
 * @param  {Date}   date Дата
 * @return {string}      2021-10-27 17:10:12
 */
export const dateFormat = function(date, format = 'Y-m-d H:i:s') {
    return format
        .replace('Y', date.getFullYear())
        .replace('m', ('0' + (date.getMonth() + 1)).slice(-2))
        .replace('d', ('0' + (date.getDate())).slice(-2))
        .replace('H', ('0' + (date.getHours())).slice(-2))
        .replace('i', ('0' + (date.getMinutes())).slice(-2))
        .replace('s', ('0' + (date.getSeconds())).slice(-2));
};

/**
 * Возвращение рандомного числа из диапазона
 * @param {number} min - минимальное число
 * @param {number} max - максимальное число
 * @returns {number}
 */
export const getRandomIntNumberInRange = function(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
};

/**
 * Удаление элемента с возможностью последующего его возвращения обратно
 * @param {HTMLElement} $element
 * @return {Function}
 */
export const unmount = function ($element) {
    const $parent = $element.parentNode;
    const $sibling = $element.nextSibling;

    $parent.removeChild($element);

    return function mount () {
        $parent.insertBefore($element, $sibling);
    };
};

/**
 * Monad
 * @param {Any} value
 * @return {Object<Optional>}
 */
export const optional = function (value) {
    return {
        then: (callback) => {
            if (value === null) {
                return optional(value);
            }

            return optional(callback(value));
        },
        get: () => value,
    };
};

export const getDatePrefix = (time) => {
    return (new Date(time)).getDate() === 2 
        ? 'со' 
        : 'с';
}
